import { useEffect, useRef, useState } from "react";

export const useStablesQuoteTimer = ({
  active = false,
  quoteKey,
  quoteDuration = 8,
  refreshing = false,
  onExpire,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(quoteDuration);
  const [barTransition, setBarTransition] = useState(true);
  const expireCalledRef = useRef(false);

  useEffect(() => {
    expireCalledRef.current = false;
  }, [quoteKey]);

  useEffect(() => {
    if (!active) {
      setSecondsLeft(quoteDuration);
      return undefined;
    }

    if (refreshing) {
      return undefined;
    }

    setSecondsLeft(quoteDuration);
    setBarTransition(false);
    const enableTransition = requestAnimationFrame(() => {
      setBarTransition(true);
    });

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          if (!expireCalledRef.current) {
            expireCalledRef.current = true;
            onExpire?.();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      cancelAnimationFrame(enableTransition);
      clearInterval(interval);
    };
  }, [active, quoteKey, quoteDuration, onExpire, refreshing]);

  const progress = quoteDuration > 0 ? (secondsLeft / quoteDuration) * 100 : 0;
  const barWidth = refreshing || secondsLeft === 0 ? 0 : progress;

  return {
    secondsLeft,
    barTransition,
    barWidth,
  };
};
